
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Loading, SpedizioniList, SpedizioniCards, LoadingTemplateType } from "@/components";
import { Spedizione, Utente, FinderSpedizioni } from '@/models';
import { FiltriOrdini, store, StoreActions, StoreMutations } from '@/store';
import { StatoSpedizione } from '@/models/enums/StatoSpedizioni';
import dayjs from 'dayjs';

@Component({
    components: {
        Loading,
        SpedizioniList,
        SpedizioniCards
    },
})
export default class Spedizioni extends Vue {


    get loading() { return store.state.loading; }

    get user() { return store.state.currentUsr; }

    get userIsAdmin() { return this.user.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined; }

    get pageSize(): number { return store.state.ui.dimensionePaginaListe; }

    get page(): number { return store.state.uiSpedizioni.pagina; }
    set page(value: number) { this.caricaPaginaSpedizioni(value); }
// set page(value: number) {
//         store.commit(StoreMutations.SetPaginaListaSpedizioni, value);
//     }

    get stati() { return Object.values(StatoSpedizione); }

    get pageCount(): number { return store.state.uiSpedizioni.totPagine; }
    get numTotSpedizioni(): number { return store.state.uiSpedizioni.totSpedizioni; }

    get spedizioni(): Spedizione[] { return store.state.listaSpedizioni; }

    get vistaLista(): boolean {
        return store.state.uiSpedizioni.listView;
    }


    get fornitori (): Utente[]  {
        return store.state.fornitori;
    }

    get fornitore (): Utente | undefined  {
        return store.state.fornitore;
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return store.state.uiSpedizioni.listView ? LoadingTemplateType.TwoLineAvatarList : LoadingTemplateType.Card;
    }

    set fornitore (fornitore: Utente | undefined) {
        store.commit(StoreMutations.SetFornitore, fornitore);
        if(fornitore) {
            this.idFornitore = fornitore.id;
            this.caricaPaginaSpedizioni(1);
        } else {
            this.idFornitore = '';
            store.commit(StoreMutations.SetSpedizioni, []);
        }
    }

    private idFornitore: string = '';

    //EDIT SPEDIZIONE SECTION
    public newSpedizioneDateMenu: boolean=false;
    public newSpedizioneDataSpedizione: string = '';
    public newSpedizioneDataSpedizioneFormatted: string = '';
    public newSpedizione = {
        dataDDT: null,
        numeroColli: 0,
        numeroDDT: '',
        note: '',
    } as Spedizione;
    public newSpedizioneDialogVisible = false;
    public openSpedizioneDialog() {
        this.newSpedizioneDialogVisible = true;
        this.newSpedizione = {
            dataDDT: null,
            numeroColli: 0,
            note: '',
            numeroDDT: '',
        } as Spedizione;
    }
    created(): void {

        if(this.userIsAdmin) {
            this.fornitore = undefined;
            store.dispatch(StoreActions.GetFornitori);
        }
        else {
            this.idFornitore = this.user.idFornitore;
            this.caricaPaginaSpedizioni(1);
        }
    }

    private caricaPaginaSpedizioni(pagina: number): void {

        if(this.idFornitore) {
            let parametri: FinderSpedizioni = new FinderSpedizioni(this.idFornitore, pagina);
            parametri.ApplicaFiltri(store.state.uiSpedizioni.filtri, store.state.uiSpedizioni.filtroStato);

            store.dispatch(StoreActions.GetSpedizioniFornitore, parametri);
        }
    }

    get filtroStatoSpedizioni(): number {
        if(store.state.uiSpedizioni.filtri) {
            return this.getStatoSpedizioneIndex(store.state.uiSpedizioni.filtroStato);
        }
        return 0;
    }
    set filtroStatoSpedizioni(value: number) {
        store.commit(StoreMutations.SetFiltroStatoSpedizioni, this.getStatoSpedizioneValue(value));
    }

    getStatoSpedizioneIndex(stato?: StatoSpedizione): number{
        if(stato){
            switch(stato) {
                case StatoSpedizione.NUOVA: return 1;
                case StatoSpedizione.COMPLETA: return 2;
                case StatoSpedizione.SPEDITA: return 3;
            }
        } else{
            return 0;
        }
    }

    getStatoSpedizioneValue(index: number): StatoSpedizione | undefined{
        switch(index) {
            case 0: return undefined //;
            case 1: return StatoSpedizione.NUOVA;
            case 2: return StatoSpedizione.COMPLETA;
            case 3: return StatoSpedizione.SPEDITA;
            default: return undefined;
        }
    }

    @Watch("$store.state.uiSpedizioni.filtri")
    onCambioFiltri(filtriNew: FiltriOrdini) {
        this.caricaPaginaSpedizioni(store.state.uiSpedizioni.pagina);
    }

    @Watch("$store.state.uiSpedizioni.filtroStato")
    onCambioFiltroStato(filtriNew: StatoSpedizione) {
        this.caricaPaginaSpedizioni(1);
    }

    parseDate (date: string): string {
        if (!date) return '';

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    formatDateForDatePicker (date: string): string {
        if (!date) return '';

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    @Watch('newSpedizioneDataSpedizione')
    onNewSpedizioneDataSpedizioneChange(): void {
        this.newSpedizioneDataSpedizioneFormatted = this.formatDateForDatePicker(this.newSpedizioneDataSpedizione)
    }

    async creaSpedizione(){
        if(this.newSpedizioneDataSpedizione){
            this.newSpedizione.dataDDT = this.newSpedizioneDataSpedizione;
        }

        const convertedNumeroColli = +this.newSpedizione.numeroColli;
        if(!Number.isNaN(convertedNumeroColli)){
            this.newSpedizione.numeroColli = convertedNumeroColli;
        }

        this.newSpedizione.righe = [];
        let esitoSpedizioneCreata = await store.dispatch(
            StoreActions.CreaSpedizione,
            this.newSpedizione
        );

        if(esitoSpedizioneCreata[0]){
            this.newSpedizioneDialogVisible = false;
            this.caricaPaginaSpedizioni(1);
        }
    }

    //Eliminazione spedizione
    public showDeleteSpedizioneDialog: boolean = false;

    get idSpedizioneForDelete() : string | null | undefined{
        return store.state.uiSpedizioni.idSpedizioneForDelete;
    }

    set idSpedizioneForDelete(id: string | null | undefined){
        store.commit(StoreMutations.SetIdSpedizioneForDelete, id);
    }

    public selectedSpedizione : Spedizione = {} as Spedizione;

    @Watch("$store.state.uiSpedizioni.idSpedizioneForDelete")
    public onIdSpedizioneForDeleteChanged(idSpedizioneForDelete : string){
        if(idSpedizioneForDelete){
            this.selectedSpedizione = this.spedizioni.find(s => s.id == idSpedizioneForDelete) ?? {} as Spedizione;
            if(this.selectedSpedizione?.id){
                this.showDeleteSpedizioneDialog = true;
            }
        } else{
            this.showDeleteSpedizioneDialog = false;
        }
    }

    public async deleteSpedizione(){
        await store.dispatch(StoreActions.EliminaSpedizione, this.idSpedizioneForDelete);
        this.caricaPaginaSpedizioni(1);
        this.idSpedizioneForDelete = null;
    }
}

